import { alert } from "notie";

const formMessage = document.querySelector(".form-message");
if (formMessage) {
    alert({ type: formMessage.dataset.type, text: formMessage.innerHTML, time: 2, position: "bottom" })
}

const clearButton = document.querySelectorAll('.clear-checkbox');

clearButton.forEach((item) => {
    item.addEventListener("click", (event) => {
        clearCheckbox(item, false);
        clearNumbers(item);

        if(item.classList.contains('with_maps')) {
            resetMap();
        }
    });
});

const clearButtonAll = document.querySelectorAll('.clear-checkbox--all');
clearButtonAll.forEach((item) => {
    item.addEventListener("click", (event) => {
        const cbs = document.querySelectorAll('.filters input[type=checkbox]'),
             cbst = document.querySelectorAll('.filters input[type=text], .filters input[type=number]');
        cbs.forEach((cb) => {
            cb.checked = false;
            copyLabel(cb);
        });

        cbst.forEach((item) => {
            item.value='';
        });
    });
});

function resetMap() {
    const pathMapActive = document.querySelectorAll(".search-map .b.active");
    pathMapActive.forEach((item) => {
        item.classList.remove("active");
    });
}

function clearCheckbox(item, checked = true) {
    const cbs = item.parentElement.querySelectorAll('input[type=checkbox]');
    cbs.forEach((cb) => {
        cb.checked = checked;
        copyLabel(item);
    });
}

function clearNumbers(item) {
    const inputs = item.parentElement.querySelectorAll('input[type=number]');
    inputs.forEach((input) => {
        input.value = null;
    });
}

const checkboxFilters = document.querySelectorAll('.filters-checkbox');
checkboxFilters.forEach((item) => {
    item.addEventListener("click", (event) => {
        copyLabel(item);
    });
});
// check label on init
const checkboxFilterInputs = document.querySelectorAll('.filters-checkbox input');
checkboxFilterInputs.forEach((item) => {
    copyLabel(item.parentNode);
});

function copyLabel(item) {
    const cbsActive = item.closest('.filters-elem-container').querySelectorAll('input[type=checkbox]:checked'),
        filtersLabel = item.closest('.filters-elem').getElementsByClassName('filters-elem-active');

    if(cbsActive.length == 0) {
        filtersLabel[0].innerHTML = document.querySelector("#select-translation").innerHTML;
    }

    if(cbsActive.length == 1) {
        filtersLabel[0].innerHTML = cbsActive[0].closest('.filters-checkbox').textContent.trim();
    }

    if(cbsActive.length > 1) {
        filtersLabel[0].innerHTML = document.querySelector("#multiple-selected-translation").innerHTML;
    }
}

function onTextareaFocus() {
    this.parentNode.classList.add("form-group-textarea--active");
}

function onTextareaBlur() {
    if (!this.value) {
        this.parentNode.classList.remove("form-group-textarea--active");
    }
}

[...document.querySelectorAll(".js-form-text")].map(
    (el) => {
        if (el.value) {
            el.parentNode.classList.add("form-group-textarea--active");
        }
        el.addEventListener("focus", onTextareaFocus);
        el.addEventListener("blur", onTextareaBlur)
    }
);

function markAsValidated(el) {
    el.classList.add("was-validated")
    const consent = el.querySelector("[name='consent']").checked;
    const privacPolicy = el.querySelector("[name='privacPolicy']").checked;
    if (!consent || !privacPolicy) {
        const checkboxMessage = document.querySelector("#invalid-checkbox-form");
        if (checkboxMessage) {
            alert({ type: "warning", text: checkboxMessage.innerHTML, time: 2, position: "bottom" })
        }
    }
}

[...document.querySelectorAll(".full-screen-form")].map(
    (el) => {
        const button = el.querySelector("button[type='submit']")
        el.addEventListener("submit", (e) => {
            if (!el.checkValidity()) {
                e.preventDefault();
            }
        });
        button.addEventListener("click", (event) => {
            markAsValidated(el);
        });
    }
);
